<div class="work-packages-partitioned-query-space--container"
  [ngClass]="currentPartition">
  <op-breadcrumbs [items]="breadcrumbItems()"
    [lastItemSection]="currentMenuSectionHeader()"
   />
  <div class="toolbar-container -editable">
    <div class="toolbar">
      @if (backButtonCallback !== undefined) {
        <op-back-button class="op-back-button"
          linkClass="op-back-button_mobile-limited-width"
          [customBackMethod]="backButtonCallback" />
      }
      <h2 class="toolbar-title--container">
        <editable-toolbar-title [title]="selectedTitle"
          [inFlight]="toolbarDisabled"
          [showSaveCondition]="showToolbarSaveButton"
          (onSave)="changeChangesFromTitle($event)"
          (onEmptySubmit)="updateTitleName('')"
          [editable]="titleEditingEnabled" />
      </h2>
      @if (showToolbar) {
        <ul class="toolbar-items hide-when-print"
          >
          @for (definition of toolbarButtonComponents; track definition) {
            @if (!definition.show || definition.show()) {
              <li class="toolbar-item"
                [ngClass]="definition.containerClasses">
                <ndc-dynamic [ndcDynamicComponent]="definition.component"
                  [ndcDynamicInputs]="definition.inputs"
                  [ndcDynamicInjector]="injector"
                  [ndcDynamicOutputs]="definition.outputs" />
              </li>
            }
          }
        </ul>
      }
    </div>
  </div>

  <div class="work-packages-partitioned-query-space--filter-area">
    @if (filterContainerDefinition) {
      <ndc-dynamic [ndcDynamicComponent]="filterContainerDefinition.component"
        [ndcDynamicInputs]="filterContainerDefinition.inputs"
        [ndcDynamicOutputs]="filterContainerDefinition.outputs"
        [ndcDynamicInjector]="injector" />
    }
  </div>

  <div class="work-packages-partitioned-page--content-container">
    <!-- Left content view -->
    <div class="work-packages-partitioned-page--content-left loading-indicator--location"
      data-indicator-name="table"
      ui-view="content-left">
    </div>

    <!-- Right content view -->
    <div class="work-packages-partitioned-page--content-right"
    ui-view="content-right"></div>
  </div>
</div>
